<script lang="ts">
  import { t } from '../../i18n/index.svelte';
  import { sceneStore } from '../../scene/store.svelte';
  import { CAMERA_TRACK, type SceneNode } from '../../scene/types';

  const nodes = $derived(sceneStore.current.nodes);

  /** Nodes in tree order with their depth. */
  const rows = $derived.by(() => {
    const out: { node: SceneNode; depth: number }[] = [];
    const walk = (parent: string | null, depth: number) => {
      for (const n of nodes.filter((x) => (x.parent ?? null) === parent)) {
        out.push({ node: n, depth });
        walk(n.id, depth + 1);
      }
    };
    walk(null, 0);
    return out;
  });

  const icon: Record<string, string> = {
    group: '▣',
    box: '◼',
    sphere: '●',
    torus: '◎',
    cylinder: '▮',
    plane: '▭',
    mesh: '◆',
    heightmap: '▤',
    terrain: '⛰',
  };

  function toggleVisible(id: string) {
    sceneStore.updateNode(id, (n) => (n.visible = !n.visible));
  }
</script>

<div class="outliner" data-testid="outliner">
  <button
    class="row cam"
    class:sel={sceneStore.selected === CAMERA_TRACK}
    onclick={() => (sceneStore.selected = CAMERA_TRACK)}
    data-testid="outliner-camera">🎥 {t('scene.camera')}</button
  >
  {#each rows as { node, depth } (node.id)}
    <div class="row" class:sel={sceneStore.selected === node.id} style:padding-left={`${8 + depth * 14}px`}>
      <button class="name" onclick={() => (sceneStore.selected = node.id)} data-testid={`outliner-${node.id}`}>
        <span class="ic">{icon[node.shape.kind] ?? '•'}</span>{node.name || node.id}
      </button>
      <button class="eye" class:off={!node.visible} title={t('scene.visible')} onclick={() => toggleVisible(node.id)}
        >👁</button
      >
    </div>
  {/each}
  {#if !rows.length}
    <p class="muted empty">{t('scene.emptyHint')}</p>
  {/if}
</div>

<style>
  .outliner {
    display: flex;
    flex-direction: column;
    gap: 1px;
  }
  .row {
    display: flex;
    align-items: center;
    border-radius: 4px;
  }
  .row.sel,
  .cam.sel {
    background: var(--panel-2);
    box-shadow: inset 2px 0 0 var(--accent);
  }
  button.name,
  .cam {
    flex: 1;
    text-align: left;
    background: none;
    border: 0;
    padding: 4px 6px;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .cam {
    padding-left: 8px;
  }
  .ic {
    display: inline-block;
    width: 18px;
    color: var(--muted);
  }
  .eye {
    background: none;
    border: 0;
    padding: 2px 6px;
    font-size: 12px;
  }
  .eye.off {
    opacity: 0.3;
  }
  .empty {
    font-size: 12px;
    padding: 6px 8px;
  }
</style>
